import type { Locale } from './catalog.js';
import { ownValue } from '../shared/runtime-values.js';

// Appearance labels stay out of the shared renderer translations.
const labels = {
  en: { appearance: 'Appearance', system: 'System', light: 'Light', dark: 'Dark' },
  es: { appearance: 'Apariencia', system: 'Sistema', light: 'Claro', dark: 'Oscuro' },
  fr: { appearance: 'Apparence', system: 'Système', light: 'Clair', dark: 'Sombre' },
  de: { appearance: 'Darstellung', system: 'System', light: 'Hell', dark: 'Dunkel' },
  pt: { appearance: 'Aparência', system: 'Sistema', light: 'Claro', dark: 'Escuro' },
  zh: { appearance: '外观', system: '跟随系统', light: '浅色', dark: '深色' },
  ja: { appearance: '外観', system: 'システム', light: 'ライト', dark: 'ダーク' },
  ru: { appearance: 'Оформление', system: 'Системное', light: 'Светлое', dark: 'Тёмное' },
  ar: { appearance: 'المظهر', system: 'النظام', light: 'فاتح', dark: 'داكن' },
} satisfies Record<Locale, { appearance: string; system: string; light: string; dark: string }>;

export function editorThemeLabels(locale: string) {
  return ownValue(labels, locale) ?? labels.en;
}
